import _ from 'lodash';

export function matchParticipantCategories(cat, options, participantCategories) {
    if (!options.length) {
        return true;
    }
    if (!participantCategories[cat]) {
        return false;
    }

    let result = options.find(option => {
        let exp = new RegExp(_.escapeRegExp(option), 'i');
        return !!participantCategories[cat].match(exp);
    });

    return !!result;
}
